/**
 * buttons.js — Awwward-winning button enhancements
 * Auto-enhances all .btn elements with:
 * - Rolling text (slot machine reveal on hover)
 * - Radial fill from cursor position
 * - Magnetic pull toward cursor
 */

(function () {
  'use strict';

  if (!window.matchMedia('(pointer: fine)').matches) return;

  function enhanceButtons() {
    var buttons = document.querySelectorAll('.btn:not(.btn--underline):not(.btn--link):not([data-btn-enhanced])');

    buttons.forEach(function (btn) {
      btn.setAttribute('data-btn-enhanced', '');

      /* ── Rolling text ── */
      var atcTextEl = btn.querySelector('.btn-add-to-cart__text');
      var textContent = btn.textContent.trim();

      if (atcTextEl && !atcTextEl.querySelector('[data-text]')) {
        /* Add-to-cart: apply rolling text to its dedicated text span,
           leave the spinner SVG untouched */
        var txt = atcTextEl.textContent.trim();
        atcTextEl.innerHTML = '<span data-text="' + txt + '">' + txt + '</span>';
        if (!btn.querySelector('.btn__fill')) {
          var fill = document.createElement('span');
          fill.className = 'btn__fill';
          btn.insertBefore(fill, btn.firstChild);
        }
      } else if (textContent && !btn.querySelector('.btn__text') && !btn.querySelector('svg')) {
        /* Regular text button */
        btn.innerHTML =
          '<span class="btn__fill"></span>' +
          '<span class="btn__text"><span data-text="' + textContent + '">' + textContent + '</span></span>';
      } else if (!btn.querySelector('.btn__fill')) {
        /* Icon-only or other buttons: just add the fill */
        var fill = document.createElement('span');
        fill.className = 'btn__fill';
        btn.insertBefore(fill, btn.firstChild);
      }

      var fillEl = btn.querySelector('.btn__fill');

      /* ── Radial fill tracks cursor (only when radial mode is active) ── */
      if (document.body.dataset.btnAnimation === 'radial') {
        btn.addEventListener('mouseenter', function (e) {
          if (!fillEl) return;
          var rect = btn.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) * 100;
          var y = ((e.clientY - rect.top) / rect.height) * 100;
          btn.style.setProperty('--fill-x', x + '%');
          btn.style.setProperty('--fill-y', y + '%');
        });

        btn.addEventListener('mouseleave', function (e) {
          if (!fillEl) return;
          var rect = btn.getBoundingClientRect();
          var x = ((e.clientX - rect.left) / rect.width) * 100;
          var y = ((e.clientY - rect.top) / rect.height) * 100;
          btn.style.setProperty('--fill-x', x + '%');
          btn.style.setProperty('--fill-y', y + '%');
        });
      }

      /* ── Click ripple ── */
      btn.addEventListener('click', function (e) {
        var rect = btn.getBoundingClientRect();
        var ripple = document.createElement('span');
        ripple.style.cssText =
          'position:absolute;border-radius:50%;background:rgba(255,255,255,0.3);' +
          'transform:scale(0);animation:btn-ripple 0.6s ease-out forwards;pointer-events:none;z-index:3;' +
          'left:' + (e.clientX - rect.left) + 'px;top:' + (e.clientY - rect.top) + 'px;' +
          'width:0;height:0;margin:-75px 0 0 -75px;width:150px;height:150px;';
        btn.appendChild(ripple);
        setTimeout(function () { ripple.remove(); }, 600);
      });
    });
  }

  /* Add ripple keyframe */
  var style = document.createElement('style');
  style.textContent = '@keyframes btn-ripple{to{transform:scale(4);opacity:0;}}';
  document.head.appendChild(style);

  /* Init + watch for new buttons */
  document.addEventListener('DOMContentLoaded', enhanceButtons);
  new MutationObserver(enhanceButtons).observe(document.body, { childList: true, subtree: true });
})();
